import { useIntl } from 'react-intl';
import { XlsxFile } from '@/utils/xslx';
import { downloadFile } from '@/utils/file/utils';
import { getHeaders } from '../utils';

export const useUploadStepVM = () => {
    const intl = useIntl();

    const sheetOptions = {
        group: {
            name: 'Groups',
            headers: getHeaders({ intl }),
        },
    };

    const onDownload = async () => {
        const sheets = {
            [sheetOptions.group.name]: [sheetOptions.group.headers],
        };

        const xslx = new XlsxFile();
        Object.keys(sheets).forEach((key) => {
            xslx.addWorksheet(key, sheets[key]);
        });

        const data = xslx.toArrayBuffer();
        const filename = `import_groups_template.xlsx`;
        downloadFile(filename, data, 'text/csv');
    };

    return { onDownload };
};
